const firebaseConfig = {
    apiKey: "AIzaSyDdkvJ939GGylluLR7rpD1wRxeWcsw6W-Y",
    authDomain: "it-solutions-bd.firebaseapp.com",
    projectId: "it-solutions-bd",
    storageBucket: "it-solutions-bd.appspot.com",
    messagingSenderId: "761250678532",
    appId: "1:761250678532:web:a3e7de99924c6f76363251"
};

export default firebaseConfig;